// Import the functions you need from the SDKs you need
import {initializeApp} from "firebase/app";
import {getAnalytics} from "firebase/analytics";
import {getAuth} from 'firebase/auth'
import {getFirestore} from 'firebase/firestore'
import {getStorage} from 'firebase/storage'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// quesuditas.ipiales@gmail.com
const firebaseConfig = {
    apiKey: "AIzaSyBTgkmxiTJj_bqim8v5Ef4SzqZAgSNt18I",
    authDomain: "quesuditasapp.firebaseapp.com",
    projectId: "quesuditasapp",
    storageBucket: "quesuditasapp.firebasestorage.app",
    messagingSenderId: "869802048346",
    appId: "1:869802048346:web:de5cd7290c46d2b57c9163",
    measurementId: "G-1MH5XZBQ4L"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);

export const auth = getAuth(app)
export const fire = getFirestore(app)
export const storage = getStorage(app)